import {FilterOption} from "./types";

type Params = {
    options: FilterOption[];
    visibleOptionsCount?: number;
    showAll?: boolean;
};

export const useCatalogOptionsFilter = (
    {
        options,
        visibleOptionsCount = 8,
        showAll = false,
    }: Params
): FilterOption[] => {
    return options.map((option, index) => ({
        ...option,
        hidden: !showAll && index >= visibleOptionsCount,
    }));
};
